import { Box, Grid } from "@mui/material";
import { useCalendar } from "../calendarContext";
import { useCalendarViews } from "./calendarViewsProvider";
import { format } from 'date-fns';
import { calendarParts, fromCalendarDate } from '../../../../../../platform/util/calendarSystem';

const YearView = () => {
    const { MonthView } = useCalendarViews();
    const { currentMonth, displayCalendar = 'gregory' } = useCalendar();

    const startYear = calendarParts(format(currentMonth || new Date(), 'yyyy-MM-dd'), displayCalendar).year;
    const months = Array.from({ length: displayCalendar === 'ethiopic' ? 13 : 12 }, (_, index) => new Date(`${fromCalendarDate(startYear, index + 1, 1, displayCalendar)}T12:00:00`));

    return (
        <Box width="100%" p={1}>
            <Grid container spacing={1} justifyContent="center">
                {months.map((monthDate, index) => (
                    <Grid
                        item
                        xs={12}   // Full width on mobile (1 month per row)
                        sm={6}    // 2 months per row on tablets (small screens)
                        md={3}    // 4 months per row on desktops (large screens)
                        lg={3}    // 4 months per row on larger screens (desktop and up)
                        key={index}
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            width: '100%',
                            minHeight: '300px', // Set a base height for each month block
                            boxSizing: 'border-box',
                            height: 'auto', // Adjust the height dynamically based on content
                            flexGrow: 1,    // Ensure equal height for all months
                        }}
                    >
                        {/* Render MonthView for each month */}
                        <MonthView
                            monthDate={monthDate} 
                            showMontHeader={true}
                            showEventMarker={true}
                        />
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};

export default YearView;
